module.exports = __webpack_public_path__ + "media/images/ui__textArrowRight--dark-6426bac6ced1cd789373eb31edca75c1.png";